import { createRouter, createRootRoute, createRoute, Outlet } from '@tanstack/react-router'

// Marketing Pages
import LandingPage from './pages/marketing/LandingPage'
import FeaturesPage from './pages/marketing/FeaturesPage'
import PricingPage from './pages/marketing/PricingPage'
import AboutPage from './pages/marketing/AboutPage'
import ContactPage from './pages/marketing/ContactPage'
import BlogPage from './pages/marketing/BlogPage'
import CareersPage from './pages/marketing/CareersPage'
import CommunityPage from './pages/marketing/CommunityPage'
import CookiesPage from './pages/marketing/CookiesPage'
import DocsPage from './pages/marketing/DocsPage'
import PressPage from './pages/marketing/PressPage'
import PrivacyPage from './pages/marketing/PrivacyPage'
import SecurityPage from './pages/marketing/SecurityPage'
import TermsPage from './pages/marketing/TermsPage'
import TutorialsPage from './pages/marketing/TutorialsPage'
import LoginPage from './pages/auth/LoginPage'
import SignupPage from './pages/auth/SignupPage'

// Dashboard App
import DashboardApp from './pages/dashboard/DashboardApp'
import ProtectedRoute from './components/auth/ProtectedRoute'

// Root route
const rootRoute = createRootRoute({
  component: () => <Outlet />,
})

// Marketing routes
const landingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: LandingPage,
})

const featuresRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/features',
  component: FeaturesPage,
})

const pricingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pricing',
  component: PricingPage,
})

const aboutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/about',
  component: AboutPage,
})

const contactRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/contact',
  component: ContactPage,
})

const blogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/blog',
  component: BlogPage,
})

const careersRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/careers',
  component: CareersPage,
})

const communityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/community',
  component: CommunityPage,
})

const cookiesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/cookies',
  component: CookiesPage,
})

const docsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/docs',
  component: DocsPage,
})

const pressRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/press',
  component: PressPage,
})

const privacyRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/privacy',
  component: PrivacyPage,
})

const securityRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/security',
  component: SecurityPage,
})

const termsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/terms',
  component: TermsPage,
})

const tutorialsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/tutorials',
  component: TutorialsPage,
})

// Auth routes
const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
})

const signupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signup',
  component: SignupPage,
})

// Dashboard route - single route, hash handles internal navigation
const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dashboard',
  component: () => (
    <ProtectedRoute>
      <DashboardApp />
    </ProtectedRoute>
  ),
})

// Build route tree
const routeTree = rootRoute.addChildren([
  landingRoute,
  featuresRoute,
  pricingRoute,
  aboutRoute,
  contactRoute,
  blogRoute,
  careersRoute,
  communityRoute,
  cookiesRoute,
  docsRoute,
  pressRoute,
  privacyRoute,
  securityRoute,
  termsRoute,
  tutorialsRoute,
  loginRoute,
  signupRoute,
  dashboardRoute,
])

// Create router
export const router = createRouter({ routeTree })

// Type declaration for router
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
